import React from "react";
import '../assets/css/print.css'
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col
} from "reactstrap";

export class ComponentToPrint extends React.PureComponent {
    BankLogoPreview=()=>{
        const Bank_id =this.props.Result.BankId ;
        console.log(Bank_id);
          if(Bank_id ==="1000"){
         return(   <img src={require("../assets/img/BankImage/meli.png").default} alt="..."
            className="avatar" />
         );
          }else if(Bank_id ==="2000"){
            return(  <img src={require("../assets/img/BankImage/parsian.png").default} alt="..."
            className="avatar" />)
          }
          else{
            return(
            <img src={require("../assets/img/BankImage/melat.png").default} alt="..."
            className="avatar" />
            )
          }
    }
    render() {
        return (
            <Col md="12" style={{textAlign:"center"}}>
                <Card className="card-info">
                    <CardHeader style={{ textAlign: "center", backgroundColor: "seagreen", padding: "20px" }}>
                        <strong style={{ fontSize: "20px", color: "white" }}>نتیجه پرداخت اینترنتی</strong>
                    </CardHeader>
                    <CardBody style={{ textAlign: "center" }}>
                        <img style={{ width: "100px", height: "100px" }} src={require("../assets/img/success.png").default} alt="MelatImage"></img>
                        <p style={{ fontSize: "20px", color: "green" }}>پرداخت موفق</p>
                        <Col md="12" style={{ marginTop: "10px" }}>
                            <Col md="7" >
                                <Row>
                                    <Col className="pr-md-1" md="12" xs="12" style={{ textAlign: "center" }}>
                                        {/* <label> عنوان </label> */}
                                        <strong>{this.props.Result.TaxType}</strong>
                                    </Col>
                                </Row>
                                <hr style={{ marginBottom: '2px' }} />

                                <Row>
                                    <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                                        <p> شناسه واریز </p>
                                        <strong>{this.props.Result.VarizId} </strong>
                                    </Col>
                                    <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                                        <p> شناسه پیگیری </p>
                                        <strong>{this.props.Result.RefNum} </strong>
                                    </Col>
                                </Row>
                                <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                                <Row>
                                    <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                                        <p>نام پرداخت کننده</p>
                                        <strong>{this.props.Result.PayerName}</strong>
                                    </Col>
                                    <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                                        <p>  تاریخ </p>
                                        <strong>{this.props.Result.EmissionDate}</strong>
                                    </Col>

                                </Row>
                                <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                                <Row>
                                    <Col className="pr-md-1" md="12" xs="12" style={{ textAlign: "center" }}>
                                        <p> مبلغ پرداختی </p>
                                        <strong style={{ fontSize: '28px', color: 'green' }}>{this.props.Result.Amount}  </strong>
                                        <p>{this.props.Result.FaAmount}</p>
                                    </Col>
                                </Row>
                            </Col>

                            <Col md="5">
                                <Card className="card-user">
                                    <div>
                                        <div className="author">
                                            <div className="block block-one" />
                                            <div className="block block-two" />
                                            <div className="block block-three" />
                                            <div className="block block-four" />
                                            {this.BankLogoPreview()}
                                            {/* {this.props.Result.BankId === "1000" ?
                                                <img src={require("../assets/img/BankImage/meli.png").default} alt="..."
                                                    className="avatar" />
                                                :
                                                <img src={require("../assets/img/BankImage/melat.png").default} alt="..."
                                                    className="avatar" />} */}

                                            <p className="description">{this.props.Result.BankName}</p>
                                            <Row>
                                                <Col className="pr-md-1" md="6" xs="6">
                                                    <p>شماره حساب </p>
                                                    <strong>{this.props.Result.AccountNumber} </strong>
                                                </Col>
                                                <Col className="pr-md-1" md="6" xs="6">
                                                    <p>صاحب حساب </p>
                                                    <strong>{this.props.Result.AccountOwnerName}</strong>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>

                                </Card>
                            </Col>
                        </Col>
                        <button className="btn btn-primary" onClick={this.props.handlePrint}>چاپ</button>
                    </CardBody>
                </Card>
            </Col>
        );
    }
}